import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {


	userDetails = new BehaviorSubject<any>({});

  constructor() { }
}
